import clsx from 'clsx'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'

const PillTabPopover = ({
	title,
	leftIcon,
	rightIcon,
	children,
}: {
	title: string
	leftIcon?: any
	rightIcon?: any
	children?: any
}) => {
	// By default show PillTab
	let classes = clsx(
		'flex items-center',
		'py-1 px-4 text-labelLargeBold text-textPrimaryLight rounded-full border-solid border border-textSecondaryLight',
		'ui-selected:bg-grey800 ui-selected:text-textPrimaryDark',
		'disabled:text-textInactiveLight disabled:border-transparent',
		'hover:border-textPrimaryLight',
		'dark:border-textSecondaryDark dark:text-textPrimaryDark',
		'dark:hover:border-textPrimaryDark',
		'dark:ui-selected:bg-white dark:ui-selected:text-rulePrimaryDark',
		'dark:disabled:border-transparent dark:disabled:text-textInactiveDark',
	)

	return (
		<Popover className="relative">
			<PopoverButton className={classes}>
				{leftIcon}
				{title}
				{rightIcon}
			</PopoverButton>

			<PopoverPanel className="absolute z-10">
				<div className="mt-2 w-64 flex-col rounded-lg bg-grey950 p-4 dark:bg-white">
					{children}
				</div>
			</PopoverPanel>
		</Popover>
	)
}

export default PillTabPopover
